import React from "react";
import { MenuTypes } from "../../enums";

interface INormalButtonProps {
  buttonProps: IButtonProps;
  buttonTools: IButtonTools;
}

interface IButtonProps {
  icon: string;
  title: string;
  numbersFromTop: number;
  showChip?: boolean;
  chipBackgroundColor?: string;
  chipTextColor?: string;
  chipCount?: number;
  buttonCategoryEnum?: MenuTypes;
  startFromBottom: boolean;
  onClick?: Function;
  highlightButton?: boolean;
}

interface IButtonTools {
  categorySelected: MenuTypes | null;
  setCategorySelected: Function;
  setSelectedMarkerId: Function;
  setSearch: Function;
}

const buttonHeightMultiplier = 63;

const ToolBarButton: React.FC<INormalButtonProps> = ({
  buttonProps,
  buttonTools,
}: INormalButtonProps) => {
  const {
    categorySelected,
    setCategorySelected,
    setSelectedMarkerId,
    setSearch,
  } = buttonTools;
  const {
    icon,
    title,
    numbersFromTop,
    startFromBottom,
    showChip = true,
    chipBackgroundColor = "#007AFF",
    chipTextColor = "white",
    buttonCategoryEnum = MenuTypes.Unknown,
    chipCount = 0,
    onClick = () => {
      setCategorySelected(buttonCategoryEnum);
      setSelectedMarkerId(null);
      setSearch("");
    },
    highlightButton = categorySelected === buttonCategoryEnum,
  } = buttonProps;

  const useClickHandler = () => {
    onClick();
  };

  return (
    <span
      className="bar-button"
      style={{
        top:
          startFromBottom === false
            ? numbersFromTop * buttonHeightMultiplier
            : "",
        bottom:
          startFromBottom === true
            ? numbersFromTop * buttonHeightMultiplier
            : "",
        borderRadius:
          numbersFromTop !== 0
            ? ""
            : startFromBottom
            ? "0px 0px 8px 8px"
            : "8px 8px 0px 0px",
        background: highlightButton ? "#626262" : "#414141",
      }}
      onClick={useClickHandler}
    >
      <div className="button-icon">
        <img src={icon} alt="" />
      </div>
      <div className="button-text">{title}</div>
      {showChip && chipCount > 0 && (
        <span
          className="chip"
          style={{
            background: chipBackgroundColor,
            color: chipTextColor,
            top: Number(buttonHeightMultiplier * 0.5 - 7.5).toString() + "px",
          }}
        >
          {chipCount > 99 ? "99+" : chipCount}
        </span>
      )}
    </span>
  );
};

export default ToolBarButton;
